import React from 'react';
import { Badge } from 'reactstrap';

function ReportingTypeField({ value, maxLength }) {
  if (!value) return <>-</>;

  if (value === 'NOT_RECURRENT') {
    return (
      <div className="master-yes">
        <Badge>Non ricorrente</Badge>
      </div>
    );
  } else if (value === 'RECURRENT') {
    return (
      <div className="master-paid">
        <Badge>Ricorrente</Badge>
      </div>
    );
  } else {
    return <>-</>;
  }
}

export default ReportingTypeField;
